import React from 'react';
import { useViewConfig } from '../../hooks/useViewConfig';
import { GAME_CARD_BRAND_CONFIG } from '../../constants/viewConfig';

const GameCard = (props) => {
  const Card = useViewConfig(GAME_CARD_BRAND_CONFIG);

  return <Card {...props} />;
};

export default GameCard;
